import { findParams } from 'core/utils';

class BaseService {
	apiClient = null;
	routeService = null;

	constructor(apiClient, routeService) {
		this.apiClient = apiClient;
		this.routeService = routeService;
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.get(url);
	}

	get(id, options = {}) {
		var url = this.routeService.get(id, options);
		return this.apiClient.get(url);
	}

	create(resource, sourceOfChange) {
		var url = this.routeService.create(sourceOfChange);
		return this.apiClient.post(url, resource);
	}

	update(resource, sourceOfChange) {
		var url = this.routeService.update(resource, sourceOfChange);
		return this.apiClient.put(url, resource);
	}

	delete(resource) {
		var url = this.routeService.delete(resource);
		return this.apiClient.delete(url);
	}

	exportToCsv(filter) {
		var url = this.routeService.exportToCsv(filter);
		return this.apiClient.post(url, findParams(filter));
	}
}

export default BaseService;



// WEBPACK FOOTER //
// ./src/core/services/BaseService.js